exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-product-guided-checkout[data-v-04f18bc8]{margin:0;padding-top:0;border-top:0}.o-product-guided-checkout__bundle-engine[data-v-04f18bc8]{display:none}.o-product-guided-checkout__steps[data-v-04f18bc8]{display:grid;gap:0}[data-v-04f18bc8].has-guided-checkout-bar{scroll-padding-bottom:220px}@media (min-width: 1024px){[data-v-04f18bc8].has-guided-checkout-bar{scroll-padding-bottom:180px}}\n", ""]);

// exports
